<template>
  <div id='App'>
    <!--<PasswordVeil />-->
    <ScrollFader id='ScrollFader' :fade-distance="300" :show-distance="150">
      <Navigation :kql="kql" />
    </ScrollFader>
    <ViewTransitions @transitionStarted="started" @transitionEnded="ended" />
  </div>
</template>

<script setup>
//import Fade from './components/Fade.vue'
import { useRoute } from 'vue-router'
import { watch, ref } from 'vue'
//import MainHeader from './components/MainHeader.vue'
//import MainFooter from './components/MainFooter.vue'
import ViewTransitions from './components/ViewTransitions.vue'
import PasswordVeil from './components/PasswordVeil.vue'
import { useStore } from './KQL.js'

//Get route so we know where we are.
const route = useRoute()
const isProduction = ref(route.path.split('/')[2] == 'productions' && !!route.path.split('/')[3])

//Setup Kirby (Timeout just so we don't load it too quickly.)
const kql = useStore();
setTimeout(function() { kql.loadPageAndSite(route.path, route.name) });

//Bind Router and KQLStore
watch(route, (route) => kql.loadPage(route.path, route.name));
watch(route, (route) => { isProduction.value = route.path.split('/')[2] == 'productions' && !!route.path.split('/')[3]});

//Watch transition emits.
const transitionActive = ref(false)
const started = () => {transitionActive.value = true}
const ended = () => {transitionActive.value = false}
</script>

<style scoped>
  div {
    width: 100%;
    overflow-x: hidden;
  }
</style>
